import * as React from 'react';
import { cn } from '@/lib/utils';

export interface MHSkeletonProps extends React.HTMLAttributes<HTMLDivElement> {}

export function MHSkeleton({ className, ...props }: MHSkeletonProps) {
  return <div className={cn('animate-pulse rounded-lg bg-surface-2', className)} {...props} />;
}
